import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";

@Injectable()
export class NoopInterceptor implements HttpInterceptor {
  constructor(
    private route: Router,
    private toastr: ToastrService,
    private CommonService: CommonService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      req.url.includes("Account/Login") ||
      req.url.includes("Account/SetToken")
    ) {
      return next.handle(req);
    }
    const authToken = localStorage.getItem("tkn");

    // Clone the request and add the Authorization header if token is present
    const secureReq = authToken
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        })
      : req;

    // return next.handle(secureReq).pipe(
    //   catchError((error: HttpErrorResponse) => {
    //     if (error.status === 400) {
    //       this.toastr.error("Bad Request:");
    //     } else if (error.status === 401) {
    //       this.toastr.error("Unauthorized:");
    //       this.route.navigate(["/UnauthorizedComponent"]);
    //       localStorage.clear();
    //     } else if (error.status === 403) {
    //       this.toastr.error("Forbidden:");
    //     } else if (error.status === 404) {
    //       this.toastr.error("Not Found:");
    //     } else if (error.status === 500) {
    //       this.toastr.error("Internal Server Error:");
    //     } else if (error.status === 502) {
    //       this.toastr.error("Bad Gateway");
    //     } else {
    //       this.toastr.error("An error occurred:");
    //     }

    //     return throwError(error);
    //   }),
    // );
    return next.handle(secureReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.error("Network/CORS Error:", error);

          this.toastr.error("Internal Server Error please try again later");

          return throwError(() => error);
        }

        switch (error.status) {
          case 400:
            const message =
              error?.error?.Message || error?.error?.message || "Bad Request";

            this.toastr.error(message);
            this.CommonService.deactivateSpinner();
            break;

          case 401:
            this.toastr.error("Unauthorized Access");

            localStorage.clear();
            sessionStorage.clear();

            this.route.navigate(["/UnauthorizedComponent"]);
            console.log("interceptor");
            this.CommonService.deactivateSpinner();
            const authToken = localStorage.getItem("tkn");
            console.log("Token:", authToken);

            const secureReq = authToken
              ? req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${authToken}`,
                  },
                })
              : req;

            console.log("Headers:", secureReq.headers);
            break;

          case 403:
            this.toastr.error("Access Denied");
            this.CommonService.deactivateSpinner();
            break;

          case 404:
            this.toastr.error("Resource Not Found");
            this.CommonService.deactivateSpinner();
            break;

          case 500:
            this.toastr.error("Internal Server Error");
            this.CommonService.deactivateSpinner();
            break;

          case 502:
            this.toastr.error("Internal Server Error please try again later");
            this.CommonService.deactivateSpinner();
            break;

          case 503:
            this.toastr.error("Service Unavailable");
            this.CommonService.deactivateSpinner();
            break;

          case 504:
            this.toastr.error("Gateway Timeout");
            this.CommonService.deactivateSpinner();
            break;

          // default:
          //   this.toastr.error(
          //     error?.error?.message || "An unexpected error occurred",
          //     `Error ${error.status}`,
          //   );
          //   this.CommonService.deactivateSpinner();

          //   break;
        }

        return throwError(() => error);
      }),
    );
  }
}
